export default [
  {
    type: 'Container',
    items: [
      {
        type: 'ActionSet',
        actions: [
          {
            type: 'Action.OpenUrl',
            title: 'Open',
            url: '{{objectUrl}}',
          },
        ],
        horizontalAlignment: 'Center',
      },
    ],
  },
];
